module.exports = __webpack_public_path__ + "video/B-A-005_SAF_BTB_Clicks.1e9cf146.vtt";